import * as sonbpIfconst from "../sonbpIf/base/constants";
import { BaseLogicClass } from "./edit.baseLogic";
import { constDialogMessage, dialogUtil } from "../util";
import { util } from "..";
import { itemVenderProperty, sonbpIFContoroller } from "./edit.sonbp_if";
import { Logger } from "../util/logger";
import { EDIT_MODE_KIND } from "./edit.const";
import { uploadPhoto } from "./edit.entity";


/**
 * 右ペイン オブジェクト操作パネル 向けの各種処理
 * ※ 全処理モード共通の動作のみをここに配置しています。各モード専用動作はそれぞれのxxxxLogic.tsに配置すること。
 */
export class ObjectManiLogicClass extends BaseLogicClass {

// #region ■定数・変数

    protected _uploadPhotoList: uploadPhoto[];
    protected _uploadMyStampList: uploadPhoto[];
    protected _uploadTegakiStampList: uploadPhoto[];

// #endregion

// #region ■起動

    /**
     * 初期化
     * @override
     */
    public init(v: Vue, sonbpIf: sonbpIFContoroller, usePcDesign: boolean, authToken: string) {
        super.init(v, sonbpIf, usePcDesign, authToken);

        this._uploadPhotoList = (<any>this._edctrl)._photoLogic._uploadImageList;
        this._uploadMyStampList = (<any>this._edctrl)._myStampLogic._uploadImageList;
        this._uploadTegakiStampList = (<any>this._edctrl)._tegakiStampLogic._uploadImageList;
    }

// #endregion

// #region ■イベント

    /**
     * 操作パネル→回転(90度)ボタン押下メソッド
     * */
    public btnClickRotate90(rotateRight: boolean, event: JQueryEventObject): void {

        const setDeg: number = rotateRight ? 90 : -90;

        // sonbpへ回転依頼
        this.sonbpIfController.rotateItem(setDeg,
            () => {
                // 正常終了の場合
            },
            () => {
                // 上記以外の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_ROTATE_PHOTO, dialogUtil.closeErrorDialog);
            });
    }

    /**
     * 操作パネル→回転(1度)ボタン押下メソッド
     * */
    public btnClickRotate1(rotateRight: boolean, event: JQueryEventObject): void {

        const setDeg: number = rotateRight ? 1 : -1;

        // sonbpへ回転依頼
        this.sonbpIfController.rotateItem(setDeg,
            () => {
                // 正常終了の場合
            },
            () => {
                // 上記以外の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_ROTATE_PHOTO, dialogUtil.closeErrorDialog);
            });
    }

    /**
     * 操作パネル→拡大／縮小ボタン押下メソッド
     * */
    public btnClickScale(scaleUp: boolean, event: JQueryEventObject): void {

        const setScale: number = scaleUp ? 1.05 : 0.95;

        // sonbpへ拡縮依頼
        this.sonbpIfController.scaleItem(setScale,
            () => {
                // 正常終了の場合
            },
            () => {
                // 上記以外の場合
                const msg: string = scaleUp ? constDialogMessage.ERROR_EDIT_SCALEUP_PHOTO : constDialogMessage.ERROR_EDIT_SCALEDOWN_PHOTO;
                util.dialogUtil.createErrorDialog(msg, dialogUtil.closeErrorDialog);
            });
    }

    /**
     * 操作パネル→移動ボタン押下メソッド
     * */
    public btnClickMove(whichMove: number, event: JQueryEventObject): void {

        let x: number;
        let y: number;

        if (whichMove === 1) {
            // 上へ移動
            x = 0;
            y = 1;

        } else if (whichMove === 2) {
            // 下へ移動
            x = 0;
            y = -1;

        } else if (whichMove === 3) {
            // 右へ移動
            x = 1;
            y = 0;

        } else {
            // 左へ移動
            x = -1;
            y = 0;
        }

        // sonbpへ拡縮依頼
        this.sonbpIfController.moveItem(x, y,
            () => {
                // 正常終了の場合
            },
            () => {
                // 上記以外の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_MOVE_PHOTO, dialogUtil.closeErrorDialog);
            });
    }

    /**
     * スタンプ削除ボタン押下
     * ※ MSTスタンプ、Myステッカー、手書きスタンプ の共通動作
     */
    public btnClickStampDelete(event: JQueryEventObject): void {

        // 選択スタンプ取得
        const selectItem: itemVenderProperty = this.sonbpIfController.getSelectItem();

        // sonbpへ削除依頼
        this.sonbpIfController.removeStampByCurrent(
            () => {
                // 正常終了の場合
                Logger.debug("スタンプ削除 成功 =>", selectItem);

                // 残スタンプを確認
                this.sonbpIfController.getAllStampList((stampList: itemVenderProperty[]) => {

                    const that = this;
                    stampList = stampList.filter(item => {
                        if (that._edctrl.editMode == EDIT_MODE_KIND.STAMP && item.item_type == sonbpIfconst.ITYPE_STAMP_IMG) return true;
                        if (that._edctrl.editMode == EDIT_MODE_KIND.MYSTAMP && item.item_type == sonbpIfconst.ITYPE_MYSTAMP_IMG) return true;
                        if (that._edctrl.editMode == EDIT_MODE_KIND.FONTGENIC && item.item_type == sonbpIfconst.ITYPE_FONTGENIC_IMG) return true;
                        return false;
                    });

                    if (stampList.length === 0) {
                        // ０件の場合
                        this._vue.$data.Stamp.DelBtnEnable = false;
                        this._vue.$data.Show.OparatePalletCover = true;

                        if (this._edctrl.editMode == EDIT_MODE_KIND.MYSTAMP) {
                            this._uploadMyStampList.forEach(row => row.isUsed = false);
                        } else if (this._edctrl.editMode == EDIT_MODE_KIND.FONTGENIC) {
                            this._vue.$data.SelectTegakiColor = "";
                            this._uploadTegakiStampList.forEach(row => row.isUsed = false);
                        }
                    }
                    else {
                        // 上記以外の場合
                        if (this._edctrl.editMode == EDIT_MODE_KIND.STAMP) {
                            let leftStamp: boolean = true;
                            this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_STAMP_IMG, () => { }, () => { leftStamp = false }, () => { leftStamp = false });
                            if (leftStamp) {
                                this._vue.$data.Stamp.DelBtnEnable = true;
                            } else {
                                this._vue.$data.Stamp.DelBtnEnable = false;
                                this._vue.$data.Show.OparatePalletCover = true;
                            }
                        } else if (this._edctrl.editMode == EDIT_MODE_KIND.MYSTAMP) {
                            let leftStamp: boolean = true;
                            this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_MYSTAMP_IMG, () => { }, () => { leftStamp = false }, () => { leftStamp = false });
                            if (leftStamp) {
                                this._vue.$data.Stamp.DelBtnEnable = true;
                            } else {
                                this._vue.$data.Stamp.DelBtnEnable = false;
                                this._vue.$data.Show.OparatePalletCover = true;
                            }
                            // 使用中フラグの辻褄合わせ
                            let usedItem: itemVenderProperty = util.relic.listFind(stampList, (vp: itemVenderProperty) => { return vp.file_id === selectItem.file_id });
                            let usedFlg = false;
                            if (usedItem) {
                                usedFlg = true;
                            }
                            let used: uploadPhoto = util.relic.listFind(this._uploadMyStampList, (up: uploadPhoto) => { return up.fileId === selectItem.file_id });
                            used.isUsed = usedFlg;
                        } else if (this._edctrl.editMode == EDIT_MODE_KIND.FONTGENIC) {

                            // 未使用ならフラグ下す
                            let targetId = selectItem.file_id.split('@')[0];
                            let used: itemVenderProperty = util.relic.listFind(stampList, (vp: itemVenderProperty) => { return vp.file_id.split('@')[0] === targetId });
                            if (!used) {
                                let stamp: uploadPhoto = util.relic.listFind(that._uploadTegakiStampList, (upimg: uploadPhoto) => { return upimg.fileId === targetId });
                                if (stamp) {
                                    stamp.isUsed = false;
                                }
                            }

                            let leftStamp: boolean = true;
                            this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_FONTGENIC_IMG, () => { }, () => { leftStamp = false }, () => { leftStamp = false });
                            if (leftStamp) {
                                this._vue.$data.Stamp.DelBtnEnable = true;
                            } else {
                                this._vue.$data.Stamp.DelBtnEnable = false;
                                this._vue.$data.Show.OparatePalletCover = true;
                            }
                        }
                    }
                });

            }, () => {
                // 上記以外の場合
                Logger.error("スタンプ削除 失敗 =>", selectItem);
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_DEL_STAMP, dialogUtil.closeErrorDialog);
            });
    }

// #endregion

// #region ■内部関数
// #endregion

}
